import { NgClass, NgStyle } from '@angular/common';
import { Component, input, Input } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-wp-status-badge',
  templateUrl: './wp-status-badge.component.html',
  styleUrls: ['./wp-status-badge.component.css'],
  standalone: true,
  imports: [NgStyle, NgClass, TooltipModule],
})
export class WPStatusBadgeComponent {
  @Input({ required: true }) wpStatus!: { name: string; color: string };
  @Input() labelClasses?: string;
  readonly size = input<'sm' | 'md'>('md');
}
